if (typeof initProductSlider_G === "undefined") {
	let initProductSlider_G = null;
}

(function () {
	const initProductAccordion = () => {
		$(".product__additional").click(function () {
			if (!$(this).hasClass("active")) {
				$(".product__additional.active").removeClass("active");
				$(this).addClass("active");
				$(".product__additional-description")
					.hide()
					.eq($(this).index())
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(".product__additional-description")
					.eq($(this).index())
					.slideToggle(300);
			}
		});
	};

	const initProductSlider = () => {
		// 2026-10-01: the main product gallery is now a stacked, normally-scrolling
		// list of full images (see section-main-product.css) instead of a Flickity
		// carousel, so the slider is intentionally NOT initialized on
		// ".product-section .product__media-list" or ".product-section .product__media-sublist"
		// anymore. The theme's own CSS already falls back to a clean stacked layout
		// and hides the thumbnail row / arrows when Flickity isn't active
		// (see ".product__media-sublist:not(.flickity-enabled)" in section-main-product.css).
	}

	initProductSlider_G = initProductSlider;

	document.addEventListener("shopify:section:load", function () {
		if (Shopify.designMode) {
			initProductSlider();
			initProductAccordion();
			initModal("fancy-container-info");
		}
	});

	initProductSlider();
	initModal("fancy-container-info");
	initProductAccordion();
})();
